import QuestionnairesWrapper from './QuestionnairesWrapper';

export default QuestionnairesWrapper;
